import React from "react";
import Icon from "@ant-design/icons";

const FILLED = "M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2z";
const OUTLINED = "M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z";

const TocIcon = ({ excluded = false, ...props }) => (
    <Icon
        component={() => (
            <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor">
                <path d={excluded ? OUTLINED : FILLED} />
            </svg>
        )}
        {...props}
    />
);

export default TocIcon;
